<template lang="pug">
  .content
    ui-navbar-panel(title="Настройки")
    pre
      | {{ settings }}

    pre
      | {{ schedule }}
</template>

<script>
import api from '@/api';

export default {
  name: 'view-cron-settings',

  data: () => ({
    settings: [],
    schedule: null,
  }),

  methods: {
    loadSettings() {
      api
        .for('cron-server')
        .read('settings')
        .then((response) => {
          this.settings = response.data;
          this.schedule = response.schedule;
        });
    },
  },

  created() {
    this.loadSettings();
  },
};
</script>
